(function () {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), wait);
    };
  }

  function escapeHtml(str) {
    return (str || "").replace(/[&<>"']/g, (m) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    }[m]));
  }

  async function fetchSuggestions(q) {
    const url =
      `/search/suggest.json?q=${encodeURIComponent(q)}` +
      `&resources[type]=product,collection` +
      `&resources[limit]=6` +
      `&resources[options][unavailable_products]=hide`;

    const res = await fetch(url, { headers: { "Accept": "application/json" } });
    if (!res.ok) return null;
    return res.json();
  }

  function renderResults(container, data) {
    const results = data?.resources?.results || {};
    const products = results.products || [];
    const collections = results.collections || [];

    const html = [];

    collections.forEach(c => {
      html.push(`
        <a href="${c.url}">
          <div class="slideshow-search__meta">
            <strong>${escapeHtml(c.title)}</strong>
            <span class="slideshow-search__type">Collection</span>
          </div>
        </a>
      `);
    });

    products.forEach(p => {
      const img = p.image
        ? `<img class="slideshow-search__thumb" src="${p.image}" alt="${escapeHtml(p.title)}">`
        : "";
      html.push(`
        <a href="${p.url}">
          ${img}
          <div class="slideshow-search__meta">
            <strong>${escapeHtml(p.title)}</strong>
            <span class="slideshow-search__type">Product</span>
          </div>
        </a>
      `);
    });

    if (!html.length) {
      container.innerHTML = `<div style="padding:12px;opacity:.75;">No matches found</div>`;
      container.hidden = false;
      return;
    }

    container.innerHTML = html.join("");
    container.hidden = false;
  }

  function closeResults(container) {
    container.hidden = true;
    container.innerHTML = "";
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".slideshow-search__form").forEach((form) => {
      const input = form.querySelector(".slideshow-search__input");
      const results = form.querySelector(".slideshow-search__results");
      if (!input || !results) return;

      const run = debounce(async () => {
        const q = input.value.trim();
        if (q.length < 2) {
          closeResults(results);
          return;
        }

        const data = await fetchSuggestions(q);
        if (!data) {
          closeResults(results);
          return;
        }
        renderResults(results, data);
      }, 200);

      input.addEventListener("input", run);

      document.addEventListener("click", (e) => {
        if (!form.contains(e.target)) closeResults(results);
      });

      input.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeResults(results);
      });
    });
  });
})();
